import React from 'react';
import {
  ALL_AUM_BUCKET_IDS,
  AUM_FILTER_BUCKETS,
  type AumBucketId,
} from './aumFilterBuckets';

type Props = {
  selected: AumBucketId[];
  onChange: (next: AumBucketId[]) => void;
  showActions?: boolean;
};

export default function AumBucketFilter({ selected, onChange, showActions = true }: Props) {
  const toggle = (id: AumBucketId) => {
    onChange(
      selected.includes(id)
        ? selected.filter((x) => x !== id)
        : [...selected, id],
    );
  };

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: '#1a237e' }}>
        AUM (выбрано {selected.length} из {AUM_FILTER_BUCKETS.length})
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px 16px' }}>
        {AUM_FILTER_BUCKETS.map((bucket) => (
          <label
            key={bucket.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              cursor: 'pointer',
              fontSize: 13,
              color: '#333',
            }}
          >
            <input
              type="checkbox"
              checked={selected.includes(bucket.id)}
              onChange={() => toggle(bucket.id)}
              style={{ width: 16, height: 16, accentColor: '#1a237e', flexShrink: 0 }}
            />
            <span>{bucket.label}</span>
          </label>
        ))}
      </div>
      {showActions && (
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            type="button"
            onClick={() => onChange([...ALL_AUM_BUCKET_IDS])}
            style={{
              backgroundColor: '#1a237e',
              color: 'white',
              border: 'none',
              borderRadius: 4,
              padding: '6px 12px',
              fontSize: 12,
              cursor: 'pointer',
            }}
          >
            Выбрать все
          </button>
          <button
            type="button"
            onClick={() => onChange([])}
            style={{
              backgroundColor: '#f5f5f5',
              color: '#666',
              border: '1px solid #ddd',
              borderRadius: 4,
              padding: '6px 12px',
              fontSize: 12,
              cursor: 'pointer',
            }}
          >
            Очистить
          </button>
        </div>
      )}
    </div>
  );
}
